import ApplicationController from './application_controller.js'

// Opens a modal when a table row is clicked. Put the controller on the tbody and
// give each row a hidden [data-row-modal-link] anchor pointing at the modal URL.
// Clicks on the row's own links, buttons and inputs are left alone.
const INTERACTIVE_SELECTOR = 'a, button, input, select, textarea, label'

export default class extends ApplicationController {
  open(event) {
    if (event.target.closest(INTERACTIVE_SELECTOR)) return
    if (!document.getSelection().isCollapsed) return

    const row = event.target.closest('tr')
    row?.querySelector('[data-row-modal-link]')?.click()
  }
}
